/** XPEN-3654: display IDs only; keep aligned with the API's EXPENSE_FORM_LABEL_IDS. */
export const EXPENSE_FORM_FIELDS = [
  { id: 'field_invoice_number', translationKey: 'review_expense.invoice_number', group: 'invoice' },
  { id: 'field_invoice_date', translationKey: 'review_expense.invoice_date', group: 'invoice' },
  { id: 'field_expense_date', translationKey: 'review_expense.date.label', group: 'invoice' },
  { id: 'field_expense_type', translationKey: 'review_expense.expense_type.label', group: 'classification' },
  { id: 'field_billable', translationKey: 'review_expense.billable.label', group: 'classification' },
  { id: 'field_matter', translationKey: 'review_expense.matter.label', group: 'classification' },
  { id: 'field_imputation_level1', translationKey: 'review_expense.imputation_level1.label', group: 'classification' },
  { id: 'field_imputation_leaf', translationKey: 'review_expense.imputation_subcategory.label', group: 'classification' },
  { id: 'field_cost_type', translationKey: 'review_expense.expense_types.label', group: 'classification' },
  { id: 'field_activity', translationKey: 'invoice.activity', group: 'classification' },
  { id: 'field_supplier_event', translationKey: 'review_expense.supplier_event.label', group: 'details' },
  { id: 'field_narrative', translationKey: 'review_expense.narrative.label', group: 'details' },
  { id: 'field_amount', translationKey: 'review_expense.amount.label', group: 'details' },
  { id: 'field_tips', translationKey: 'tips', group: 'details' },
  { id: 'field_tax_code', translationKey: 'tax_codes', group: 'details' },
  { id: 'field_location', translationKey: 'review_expense.location.label', group: 'travel' },
  { id: 'field_number_of_guests', translationKey: 'review_expense.number_of_guests.label', group: 'travel' },
  { id: 'field_mileage', translationKey: 'review_expense.mileage.label', group: 'travel' },
];

/** Resolve at render time so an empty override follows the current UI language. */
export const getExpenseFormLabel = (data, fieldId) => {
  const override = data.config?.expenses?.form?.labels?.[fieldId];
  return typeof override === 'string' && override.trim()
    ? override.trim()
    : data.t.read(EXPENSE_FORM_FIELDS.find(({ id }) => id === fieldId).translationKey);
};

/** Persist overrides only; clearing a textbox restores its translated default. */
export const normalizeExpenseFormLabels = (draft) => Object.fromEntries(
  EXPENSE_FORM_FIELDS
    .filter(({ id }) => typeof draft?.[id] === 'string' && draft[id].trim())
    .map(({ id }) => [id, draft[id].trim()]),
);
